module.exports = __webpack_public_path__ + "diamond-image01.png?d95584a22e4016b0d5d66a94a43ae061";